import { FC, useEffect } from "react";
// import shareInfo from "../router/wx";
const ConsumeTitleHoc = (C: FC, title: string = "\u200E"): FC => {
    const NewC: FC = (props: any) => {
        useEffect(() => {
            document.querySelector("title")!.innerText = title;
            // shareInfo.init();
        }, []);
        return <C {...props} />;
    };
    return NewC;
};

export default ConsumeTitleHoc;
